// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KcMiw","buttons":"styles_buttons__2LxeS"};